export default {
  'menu.commerce': '商品与订单',
  'pages.commerce.action.column': '操作',
  'pages.commerce.action.detail': '详情',
  'pages.commerce.action.disable': '停用',
  'pages.commerce.action.edit': '编辑',
  'pages.commerce.action.price': '价格',
  'pages.commerce.action.query': '查询',
  'pages.commerce.action.refresh': '刷新',
  'pages.commerce.empty.data': '暂无数据',
  'pages.commerce.message.saved': '操作成功',
  'pages.commerce.order.amount': '金额',
  'pages.commerce.order.createdAt': '创建时间',
  'pages.commerce.order.currency': '币种',
  'pages.commerce.order.dateRange': '日期范围',
  'pages.commerce.order.detail.basic': '基础信息',
  'pages.commerce.order.detail.skuSnapshot': '商品快照',
  'pages.commerce.order.detail.statusTime': '状态与时间',
  'pages.commerce.order.drawerTitle': '订单详情',
  'pages.commerce.order.field.amount': '金额',
  'pages.commerce.order.field.createdAt': '创建时间',
  'pages.commerce.order.field.currency': '币种',
  'pages.commerce.order.field.expiresAt': '过期时间',
  'pages.commerce.order.field.fulfilledAt': '履约时间',
  'pages.commerce.order.field.memo': '备注',
  'pages.commerce.order.field.orderId': '订单 ID',
  'pages.commerce.order.field.paidAt': '支付时间',
  'pages.commerce.order.field.payMethod': '支付方式',
  'pages.commerce.order.field.sendOrderId': '发送订单 ID',
  'pages.commerce.order.field.skuId': 'SKU ID',
  'pages.commerce.order.field.skuSnapshotType': '商品类型',
  'pages.commerce.order.field.status': '订单状态',
  'pages.commerce.order.field.updatedAt': '更新时间',
  'pages.commerce.order.field.userId': '用户 ID',
  'pages.commerce.order.field.walletRedPacketId': '红包钱包 ID',
  'pages.commerce.order.fulfilledAt': '履约时间',
  'pages.commerce.order.level.effectiveFrom': '生效时间',
  'pages.commerce.order.level.effectiveUntil': '失效时间',
  'pages.commerce.order.level.tier': '等级',
  'pages.commerce.order.level.tierName': '等级名称',
  'pages.commerce.order.level.title': '会员等级',
  'pages.commerce.order.orderId': '订单 ID',
  'pages.commerce.order.page': '页码',
  'pages.commerce.order.pageSize': '每页数量',
  'pages.commerce.order.paidAt': '支付时间',
  'pages.commerce.order.payMethod': '支付方式',
  'pages.commerce.order.skuSnapshot': '商品快照',
  'pages.commerce.order.skuId': 'SKU ID',
  'pages.commerce.order.skuType': '商品类型',
  'pages.commerce.order.status': '订单状态',
  'pages.commerce.order.status.created': '已创建',
  'pages.commerce.order.status.pending': '待处理',
  'pages.commerce.order.status.paying': '支付中',
  'pages.commerce.order.status.paid': '已支付',
  'pages.commerce.order.status.done': '已完成',
  'pages.commerce.order.status.pay_failed': '支付失败',
  'pages.commerce.order.status.closed': '已取消',
  'pages.commerce.order.status.expired': '已过期',
  'pages.commerce.order.status.refunding': '退款处理中',
  'pages.commerce.order.status.refunded': '已退款',
  'pages.commerce.order.status.refund_failed': '退款失败',
  'pages.commerce.order.status.active': '待领取',
  'pages.commerce.order.status.claimed': '已领完',
  'pages.commerce.order.status.failed': '失败',
  'pages.commerce.order.status.withdrawing': '提现中',
  'pages.commerce.order.txnType': '交易类型',
  'pages.commerce.order.total': '总数',
  'pages.commerce.order.detail.queryInfo': '查询信息',
  'pages.commerce.order.summary.firstOrderAt': '首单时间',
  'pages.commerce.order.summary.orderCount': '订单数量',
  'pages.commerce.order.summary.title': '消费汇总',
  'pages.commerce.order.summary.totalRefunded': '退款总额',
  'pages.commerce.order.summary.totalSpent': '消费总额',
  'pages.commerce.order.uid': 'UID',
  'pages.commerce.order.userId': '用户 ID',
  'pages.commerce.order.userOrderDetail': '用户订单详情',
  'pages.commerce.price.active': '启用',
  'pages.commerce.price.amount': '金额',
  'pages.commerce.price.currency': '币种',
  'pages.commerce.price.payMethod': '支付方式',
  'pages.commerce.price.upsert': '新增或更新价格',
  'pages.commerce.reconcile.title': '等级对账',
  'pages.commerce.reconcile.trigger': '触发等级对账',
  'pages.commerce.sku.basicInfo': '基础信息',
  'pages.commerce.sku.code': 'SKU 编码',
  'pages.commerce.sku.create': '创建 SKU',
  'pages.commerce.sku.disableConfirm': '确认停用该 SKU？',
  'pages.commerce.sku.drawerTitle': 'SKU 详情',
  'pages.commerce.sku.durationDays': '有效天数',
  'pages.commerce.sku.edit': '编辑 SKU',
  'pages.commerce.sku.name': '名称',
  'pages.commerce.sku.priceCount': '价格数',
  'pages.commerce.sku.prices': '价格配置',
  'pages.commerce.sku.skuId': 'SKU ID',
  'pages.commerce.sku.status': '状态',
  'pages.commerce.sku.targetLevelId': '目标等级',
  'pages.commerce.sku.type': '类型',
  'pages.commerce.tab.orders': '订单查询',
  'pages.commerce.tab.reconcile': '等级对账',
  'pages.commerce.tab.skus': 'SKU 管理',
  'pages.commerce.title': '商品与订单',
};
